<template>
    <views
        :class="{'padding': padding}"
        class="banner">
        <van-swipe
            :autoplay="3000"
            :class="{'radius': radius}"
            class="my-swipe"
            indicator-color="white">
            <van-swipe-item
                v-for="(item, index) in list"
                :key="index"
                @click="handleTarget(item)">
                <images :src="item.url"></images>
            </van-swipe-item>
        </van-swipe>
    </views>
</template>

<script>
import tools from '@/mixins/tools'
export default {
    mixins: [tools],
    props: {
        list: {
            type: Array,
            default: () => []
        },
        padding: {
            type: Boolean,
            default: true
        },
        radius: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        handleTarget(row) {
            if (row.target_url) {
                this.windowPush(row.target_url)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
